import apiFetch from '../apiFetch'

export default function (filtros, token) {
  return apiFetch({endPoint: `Informes/imprimirInformeEstadoCentro`, method: 'POST', body: filtros, token: token})
}